(function () {
  if (window.__klCart) return;
  window.__klCart = true;
  var d = document;
  var reduce = (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) || d.documentElement.classList.contains('kla-still');
  var last = { tier: 0, pct: 0 }, first = true, lastTotal = null;

  function fmt(c, cur) {
    try {
      return new Intl.NumberFormat(d.documentElement.lang || undefined, { style: 'currency', currency: cur, maximumFractionDigits: 0 }).format(c / 100);
    } catch (e) { return Math.round(c / 100) + ' ' + cur; }
  }

  /* thresholds are set in the shop currency; convert them for shoppers who see another currency */
  function localize(el) {
    var cur = el.getAttribute('data-cur'), base = el.getAttribute('data-base');
    if (!cur || cur === base) return;
    var rate = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate);
    if (!rate || !isFinite(rate)) { el.style.display = 'none'; return; }
    var total = +el.getAttribute('data-total') || 0;
    /* round up so the bar never says "unlocked" before the discount really applies */
    var t1 = Math.ceil(+el.getAttribute('data-t1') * rate / 100) * 100;
    var t2 = Math.ceil(+el.getAttribute('data-t2') * rate / 100) * 100;
    var pct = Math.min(100, Math.round(total / t2 * 1000) / 10);
    var tier = total >= t2 ? 2 : (total >= t1 ? 1 : 0);
    el.setAttribute('data-tier', tier);
    el.setAttribute('data-pct', pct);
    var fill = el.querySelector('.klr__fill');
    if (fill) { fill.style.width = pct + '%'; fill.classList.toggle('is-zero', pct === 0); }
    var n1 = el.querySelector('[data-n="1"]'), n2 = el.querySelector('[data-n="2"]');
    if (n1) { n1.style.left = (t1 / t2 * 100) + '%'; n1.classList.toggle('is-on', tier >= 1); }
    if (n2) n2.classList.toggle('is-on', tier >= 2);
    var l1 = el.querySelector('[data-l="1"]'), l2 = el.querySelector('[data-l="2"]');
    if (l1) { l1.style.left = (t1 / t2 * 100) + '%'; l1.textContent = fmt(t1, cur); l1.style.visibility = ''; }
    if (l2) { l2.textContent = fmt(t2, cur); l2.style.visibility = ''; }
    var msg = el.querySelector('.klr__msg');
    if (msg) {
      if (tier === 0) msg.innerHTML = 'Add <b>' + fmt(t1 - total, cur) + '</b> more to unlock <b>10% off</b>';
      else if (tier === 1) msg.innerHTML = '<span class="klr__ok">10% off unlocked.</span> Add <b>' + fmt(t2 - total, cur) + '</b> more for <b>15% off</b>';
      else msg.innerHTML = '<span class="klr__ok">15% off unlocked.</span> Your best reward is applied at checkout.';
      msg.style.visibility = '';
    }
  }

  function burst(el) {
    if (!el.animate) return;
    var cols = ['#f3dc9a', '#d6a84f', '#ffffff', '#b8862b'];
    for (var i = 0; i < 26; i++) {
      var s = d.createElement('i');
      s.className = 'klr__dot';
      s.style.background = cols[i % cols.length];
      s.style.borderRadius = i % 3 ? '50%' : '2px';
      el.appendChild(s);
      var a = Math.random() * Math.PI * 2, r = 70 + Math.random() * 130;
      var x = Math.cos(a) * r, y = Math.sin(a) * r * 0.7 - 20;
      var an = s.animate([
        { transform: 'translate(-50%,-50%) scale(1)', opacity: 1 },
        { transform: 'translate(' + x + 'px,' + (y + 60) + 'px) rotate(' + (Math.random() * 540) + 'deg) scale(.4)', opacity: 0 }
      ], { duration: 900 + Math.random() * 600, easing: 'cubic-bezier(.16,.84,.3,1)' });
      an.onfinish = (function (n) { return function () { n.remove(); }; })(s);
    }
  }

  /* the total flashes gold whenever it changes */
  function tick() {
    var v = d.querySelector('cart-drawer .totals__total-value');
    if (!v) { lastTotal = null; return; }
    var t = v.textContent.trim();
    if (lastTotal !== null && t !== lastTotal && !reduce) {
      v.classList.remove('kl-tick');
      void v.offsetWidth;
      v.classList.add('kl-tick');
    }
    lastTotal = t;
  }

  function sync() {
    var el = d.querySelector('[data-kl-reward]');
    if (!el) { last.tier = 0; last.pct = 0; lastTotal = null; return; }
    if (el.__klDone) return;
    el.__klDone = true;
    localize(el);
    tick();
    var tier = +el.getAttribute('data-tier') || 0;
    var pct = +el.getAttribute('data-pct') || 0;
    var fill = el.querySelector('.klr__fill');
    if (fill && !reduce && !first) {
      fill.style.width = last.pct + '%';
      void fill.offsetWidth;
      requestAnimationFrame(function () { fill.style.width = pct + '%'; });
    }
    if (!first && tier > last.tier && !reduce) setTimeout(function () { burst(el); }, 650);
    last.tier = tier; last.pct = pct; first = false;
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; sync(); });
  }

  function start() {
    var host = d.querySelector('cart-drawer');
    new MutationObserver(schedule).observe(host || d.body, { childList: true, subtree: true });
    /* entrance animation only when the drawer opens, not on every cart update */
    if (host) {
      var was = host.classList.contains('active');
      new MutationObserver(function () {
        var on = host.classList.contains('active');
        if (on && !was && !reduce) {
          host.classList.add('kl-fresh');
          clearTimeout(host.__klT);
          host.__klT = setTimeout(function () { host.classList.remove('kl-fresh'); }, 1900);
        }
        was = on;
      }).observe(host, { attributes: true, attributeFilter: ['class'] });
    }
    sync();
    first = false;
  }

  d.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-kl-add]');
    if (!b || b.classList.contains('is-busy')) return;
    b.classList.add('is-busy');
    b.classList.remove('is-err');
    var cd = d.querySelector('cart-drawer');
    var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: +b.getAttribute('data-kl-add'), quantity: 1, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (s) {
      if (s.status || !s.sections) throw s;
      if (cd && typeof cd.renderContents === 'function') cd.renderContents(s);
      else window.location.href = '/cart';
    }).catch(function () {
      b.classList.remove('is-busy');
      b.classList.add('is-err');
    });
  });

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start);
  else start();
})();
